<template>
  <span>{{ prefix }}{{ formatNumber() }}</span>
</template>
<script>
export default {
  props: {
    prefix: {
      type: String,
      default: ''
    },
    amount: {
      type: Number,
      default: 200
    },
    duration: {
      type: Number,
      default: 3
    },
    delay: {
      type: Number,
      default: 0
    },
    isDecimal: {
      type: Boolean,
      default: false
    },
    addZeros: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      speed: 0,
      currentCount: 0,
      theInterval: null,
      animated: false
    }
  },
  mounted() {
    document.addEventListener('scroll', this.checkVisibility);
    this.checkVisibility();
  },
  methods: {
    checkVisibility() {
      var rect = this.$el.getBoundingClientRect();
      if (
          rect.top >= 0 &&
          rect.left >= 0 &&
          rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && /*or $(window).height() */
          rect.right <= (window.innerWidth || document.documentElement.clientWidth) /*or $(window).width() */
      ) {
        document.removeEventListener('scroll', this.checkVisibility);
        this.speed = this.amount / (this.duration * 100);
        setTimeout(() => {
          this.theInterval = setInterval(() => {
            this.currentCount = this.currentCount + this.speed;
            if (this.currentCount >= this.amount) {
              clearInterval(this.theInterval);
              this.currentCount = this.amount
            }
          }, 10);
        }, this.delay * 1000);
      }
    },
    setInterval() {
      if (this.link != null) {
        window.open(this.link, this.target);
      }
    },
    formatNumber() {
      let number = 0;
      if (this.isDecimal) {
        number = parseFloat(this.currentCount).toFixed(1);
      } else {
        number = Math.round(this.currentCount);
      }

      if (number < 10 && !this.isDecimal && this.addZeros) {
        number = '0' + number;
      }

      // Add commas
      let parts = (number).toString().split('.');
      let integer = parts[0];
      let decimalsPart = (parts[1] == undefined) ? '00' : parts[1];

      if (decimalsPart.length == 1) {
        decimalsPart += 0;
      }

      let output = String(integer).split("").reverse().join("").replace(/(\d{3}\B)/g, "$1,").split("").reverse().join("");

      if (this.isDecimal) {
        output += '.' + decimalsPart;
      }

      return output;
    }
  }
}
</script>
